export default __webpack_public_path__ + "static/media/result_medium.a9a509fe.png";